"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FoodOrder = exports.BannerType = void 0;
Object.defineProperty(exports, "FoodOrderServiceType", {
  enumerable: true,
  get: function get() {
    return _useServiceType.FoodOrderServiceType;
  }
});
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _useTracking = require("../../hooks/useTracking");
var _foodShop = _interopRequireDefault(require("../../assets/images/food-shop.svg"));
var _food_circle = _interopRequireDefault(require("../../assets/images/food_circle.svg"));
var _foodBuyer = _interopRequireDefault(require("../../assets/images/food-buyer.svg"));
var _new_buyer_info = _interopRequireDefault(require("../../assets/images/new_buyer_info.svg"));
var _new_shop_name = _interopRequireDefault(require("../../assets/images/new_shop_name.svg"));
var _useServiceType = require("./useServiceType");
var _shopNameImgMap;
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var BannerType;
exports.BannerType = BannerType;
(function (BannerType) {
  BannerType["OrderCode"] = "orderCode";
  BannerType["CreateTime"] = "createTime";
})(BannerType || (exports.BannerType = BannerType = {}));
var prefixCls = (0, _getPrefixCls.getPrefixCls)('food-order');
var shopNameImgMap = (_shopNameImgMap = {}, (0, _defineProperty2.default)(_shopNameImgMap, _useServiceType.FoodOrderServiceType.Food, _food_circle.default), (0, _defineProperty2.default)(_shopNameImgMap, _useServiceType.FoodOrderServiceType.SPXInstant, _new_buyer_info.default), (0, _defineProperty2.default)(_shopNameImgMap, _useServiceType.FoodOrderServiceType.SPXInstantShopee, _new_shop_name.default), (0, _defineProperty2.default)(_shopNameImgMap, _useServiceType.FoodOrderServiceType.SPXSameDayShopee, _new_shop_name.default), _shopNameImgMap);
var FoodOrder = function FoodOrder(props) {
  var _props$bannerType = props.bannerType,
    bannerType = _props$bannerType === void 0 ? BannerType.OrderCode : _props$bannerType,
    serviceType = props.serviceType,
    status = props.status,
    shopName = props.shopName,
    buyerInfo = props.buyerInfo,
    orderCode = props.orderCode,
    createTime = props.createTime,
    wrapperStyle = props.wrapperStyle,
    componentTrackingData = props.componentTrackingData,
    _props$onClick = props.onClick,
    onClick = _props$onClick === void 0 ? function () {
      return null;
    } : _props$onClick,
    isUIOptimisation = props.isUIOptimisation;
  var _useComponentTracking = (0, _useTracking.useComponentTracking)({
      componentTrackingData: componentTrackingData,
      componentData: _objectSpread({}, props)
    }),
    tracker = _useComponentTracking.tracker,
    panelOrderTracking = _useComponentTracking.result.panelOrder;
  var onOrderClick = function onOrderClick() {
    // 点击埋点
    (panelOrderTracking === null || panelOrderTracking === void 0 ? void 0 : panelOrderTracking.trackingClick) && tracker.click(panelOrderTracking.trackingClick);
    onClick === null || onClick === void 0 ? void 0 : onClick({
      data: props
    });
  };
  var _useServiceTypeLabelN = (0, _useServiceType.useServiceTypeLabelNode)(serviceType),
    _useServiceTypeLabelN2 = (0, _slicedToArray2.default)(_useServiceTypeLabelN, 1),
    serviceTypeLabel = _useServiceTypeLabelN2[0];
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: "".concat(prefixCls, "-container").concat(isUIOptimisation ? '-ui-optimisation' : ''),
    style: wrapperStyle,
    onClick: onOrderClick
  }, panelOrderTracking === null || panelOrderTracking === void 0 ? void 0 : panelOrderTracking.trackingImpressionProps), isUIOptimisation ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("".concat(prefixCls, "-banner"), "".concat(prefixCls, "-banner-").concat(bannerType))
  }, serviceType !== _useServiceType.FoodOrderServiceType.SPXInstant && orderCode != null && /*#__PURE__*/_react.default.createElement("p", {
    className: "".concat(prefixCls, "-banner-code")
  }, "#", orderCode), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-banner-order-type")
  }, serviceTypeLabel)) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("".concat(prefixCls, "-banner"), "".concat(prefixCls, "-banner-").concat(bannerType))
  }, bannerType === BannerType.OrderCode && /*#__PURE__*/_react.default.createElement("p", {
    className: "".concat(prefixCls, "-banner-code")
  }, "#", orderCode), bannerType === BannerType.CreateTime && /*#__PURE__*/_react.default.createElement("p", {
    className: "".concat(prefixCls, "-banner-create-time")
  }, createTime), /*#__PURE__*/_react.default.createElement("p", {
    className: "".concat(prefixCls, "-banner-status")
  }, status)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-content")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-content-shop-name")
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "".concat(prefixCls, "-content-shop-name-icon"),
    src: isUIOptimisation ? shopNameImgMap[serviceType] : _foodShop.default
  }), /*#__PURE__*/_react.default.createElement("p", null, shopName)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-content-buyer-info")
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "".concat(prefixCls, "-content-buyer-info-icon"),
    src: isUIOptimisation ? _new_buyer_info.default : _foodBuyer.default
  }), /*#__PURE__*/_react.default.createElement("p", null, buyerInfo))));
};
exports.FoodOrder = FoodOrder;